document.addEventListener("DOMContentLoaded", function () {
  // Function to handle thumbnail swatch click
  let selected_input = document.querySelector(
    ".custom-quantity-selector .variant-picker__option-values input"
  );
  if (!selected_input) return;
  const quantityInput = document.querySelector(".quantity-selector__input");
  function updateQuantity(e) {
    e.preventDefault();
    const newLabel = e.target.closest(".thumbnail-swatch");
    const newQuantity = newLabel.getAttribute("data-quantity");
    const newInput = document.querySelector(
      `input[data-quantity="${newQuantity}"]`
    );

    const optionInfoSpan = document.querySelector(
      ".custom-quantity-selector .variant-picker__option-info span"
    );

    if (optionInfoSpan) {
      optionInfoSpan.textContent = newInput.getAttribute("value");
    }

    selected_input.removeAttribute("checked");
    newInput.setAttribute("checked", "checked");
    selected_input = newInput;

    quantityInput.value = newQuantity;

    const qtyChangeEvent = new CustomEvent("qtyChange", {
      detail: {
        productId: parseInt(newInput.getAttribute("name")),
        qty: parseInt(newQuantity),
      },
      bubbles: true,
    });

    newInput.closest("variant-picker").dispatchEvent(qtyChangeEvent);
  }

  // Attach event listener to all .thumbnail-swatch elements
  const thumbnailSwatches = document.querySelectorAll(".thumbnail-swatch");

  document.addEventListener("change:discounts", function (e) {
    if (
      e.detail.productId ===
      parseInt(
        selected_input.closest("variant-picker").getAttribute("data-product-id")
      )
    ) {
      if (document.querySelector(".wf-price-per-unit--wrapper")) {
        const units = Number(
          document
            .querySelector(".wf-price-per-unit--wrapper")
            .getAttribute("data-units")
        );

        let node1 = document.querySelector(".wf-price-per-unit");
        node1.innerHTML = node1
          .getAttribute("data-template")
          .replace(
            "[price]",
            parseFloat(e.detail.price / 100 / (units * e.detail.qty)).toFixed(2)
          );

        let node2 = document.querySelector(".wf-portions");
        node2.innerHTML = node2
          .getAttribute("data-template")
          .replace("[units]", parseFloat(units * e.detail.qty));
      }
    }
  });

  thumbnailSwatches.forEach((swatch) => {
    swatch.addEventListener("click", updateQuantity);
  });
});
